import uniqolor from "uniqolor"

export function getGroupTilePresentation(parentItem, failedImage, loadedImage, options = {}) {
    const accentColor = getGroupTileAccentColor(parentItem?.label ?? parentItem?.name ?? "Folder")
    const hasImage = !!parentItem?.data?.image && parentItem.data.image !== failedImage
    if (options.alwaysTall && !hasImage) {
        return getTallGroupTilePresentation(accentColor)
    }

    if (!hasImage) {
        return {
            variant: "compact",
            accentColor,
            accentLineHeight: 6,
            avatarSize: 40,
            buttonFlex: "0 0 auto",
            cardPaddingBottom: 0,
            transition: getTileTransition(),
        }
    }

    const imageIsLoaded = parentItem.data.image === loadedImage
    if (options.alwaysTall && !imageIsLoaded) {
        return getTallGroupTilePresentation(accentColor)
    }

    if (!imageIsLoaded) {
        return {
            variant: "image",
            accentColor,
            accentLineHeight: 6,
            avatarSize: 40,
            buttonFlex: "0 0 auto",
            cardPaddingBottom: 0,
            imageOpacity: 0,
            titleMarginTop: 1.25,
            transition: getTileTransition(),
        }
    }

    return {
        variant: "image",
        accentColor,
        accentLineHeight: 150,
        avatarSize: 72,
        buttonFlex: 1,
        cardPaddingBottom: 1,
        imageOpacity: 1,
        titleMarginTop: 5,
        transition: getTileTransition(),
    }
}

function getTallGroupTilePresentation(accentColor) {
    return {
        variant: "image",
        accentColor,
        accentLineHeight: 150,
        avatarSize: 72,
        buttonFlex: 1,
        cardPaddingBottom: 1,
        imageOpacity: 1,
        titleMarginTop: 5,
        transition: getTileTransition(),
    }
}

function getGroupTileAccentColor(seed) {
    return uniqolor(seed, {
        saturation: [55, 99],
        lightness: [70, 90],
    }).color
}

function getTileTransition() {
    return "height 250ms ease, min-height 250ms ease, flex-basis 250ms ease, padding-bottom 250ms ease, margin-top 250ms ease, opacity 200ms ease, width 250ms ease"
}
